export default {
  edit: { id: 'edit' },
  title: { id: 'title' },
  dateCreated: { id: 'date_created' },
  saveInfo: { id: 'save_info' },
  jobWorkflowTranslation: { id: 'job_workflow_translation' },
  jobWorkflowList: { id: 'job_workflow_list' },
}
